module.exports = __webpack_public_path__ + "static/media/multibook.3dc0d164.svg";